import React from "react"
import PropTypes from "prop-types"

import {
  WHO_WE_ARE,
  WHAT_KIND_OF_PERSONAL_INFORMATION,
  WHO_MAY_WE_DISCLOSE_PERSONAL_INFORMATION,
  HOW_DO_WE_OBTAIN_YOUR_CONSENT,
  MANAGEMENT_OF_PERSONAL_INFORMATION,
  HOW_DO_WE_STORE_PERSONAL_INFORMATION,
  HOW_DO_WE_USE_THE_PERSONAL_INFORMATION,
  THE_PERSONAL_INFORMATION_WE_HOLD_ABOUT_YOU,
  WHAT_IS_A_COOKIE,
  TECHNOLOGY_IMPROVEMENTS,
  LINKS_TO_THIRD_PARTY_WEBSITES,
  WHAT_IF_YOU_HAVE_A_COMPLAINT,
  CONTACT_US,
} from "../constants"

const Content = ({ section }) => (
  <div className="privacy-policy-sticky-content">
    <p className="privacy-policy-content-title">{section}</p>
    {section === WHO_WE_ARE && (
      <>
        <p className="privacy-policy-content-text">
          Kaizen Reporting Limited provides quality assurance testing services
          in respect of regulatory reporting, including but not limited to
          reference data testing, accuracy testing and regulatory
          reconciliations (&quot;Kaizen Reporting&quot;).
        </p>
        <p className="privacy-policy-content-text">
          Kaizen Shareholding Disclosure Services Limited provides an automated
          platform to report and monitor shareholding disclosures (&quot;Kaizen
          SDS&quot;). Single Rulebook Limited is a software solution that
          enables users to search, share and manage regulatory rules on one
          digital platform (&quot;Single Rulebook&quot;). Kaizen Reporting,
          Kaizen SDS and Single Rulebook (together &quot;Kaizen&quot;) are part
          of the Kaizen group.
        </p>
        <p className="privacy-policy-content-text underline">
          Each of Kaizen Reporting, Kaizen SDS and Single Rulebook is a data
          controller of personal information in respect of the applicable
          services it makes available on the Hub.
        </p>
        <p className="privacy-policy-content-text">
          Please note that if you are a Kaizen employee, your personal
          information will be used in connection with your employment contract.
          Any reference to ‘us’, ‘our’ or ‘we’ in this privacy notice is a
          reference to Kaizen. Similarly, any reference to ‘you’, ‘your’,
          ‘yours’ or ‘yourself’ in this privacy notice is a reference to any of
          our customers and potential customers as the context requires unless
          otherwise stated.
        </p>
      </>
    )}
    {section === WHAT_KIND_OF_PERSONAL_INFORMATION && (
      <>
        <p className="privacy-policy-content-text">
          If you are an actual or potential customer, we may collect the
          following types of information about you:
        </p>
        <ul>
          <li className="privacy-policy-content-text">
            name, address and contact details
          </li>
          <li className="privacy-policy-content-text">
            profession and employment details
          </li>
          <li className="privacy-policy-content-text">location data</li>
          <li className="privacy-policy-content-text">
            any other similar information.
          </li>
        </ul>
        <p className="privacy-policy-content-text">
          We obtain this information in a number of ways through your use of our
          services or other dealings with us including through the Kaizen
          website, the customer on-boarding process, marketing sign up forms,
          subscribing to blogs and from information provided in the course of
          ongoing customer service correspondence. We may also obtain personal
          information about you through your use of our website or through the
          use of cookies on our website and, in particular by recording which
          pages you look at on our website.
        </p>
        <p className="privacy-policy-content-text">
          We may ask for other personal information voluntarily from time to
          time (for example, through market research or surveys). We may record
          any communications, electronic, by telephone, in person or otherwise,
          that we have with you in relation to the services we provide to you
          and our relationship with you. These recordings will be our sole
          property and will constitute evidence of the communications between
          us. Such telephone conversations may be recorded without the use of a
          warning tone or any other further notice. Further, if you visit our
          offices or premises, we may have CCTV which will record your image.
        </p>
      </>
    )}
    {section === WHO_MAY_WE_DISCLOSE_PERSONAL_INFORMATION && (
      <>
        <p className="privacy-policy-content-text">
          As part of using your personal information for the purposes set out
          above, we may disclose your information to:
        </p>
        <ul>
          <li className="privacy-policy-content-text">
            service providers and specialist advisers who have been contracted
            to provide us with administrative, IT, financial, regulatory,
            compliance, insurance, research or other services
          </li>
          <li className="privacy-policy-content-text">
            courts, tribunals and applicable regulatory authorities as agreed or
            authorised by law or our agreement with you
          </li>
          <li className="privacy-policy-content-text">
            anyone authorised by you.
          </li>
        </ul>
        <p className="privacy-policy-content-text">
          Generally, we require that third party organisations who handle or
          obtain personal information acknowledge the confidentiality of this
          information, undertake to respect any individual’s right to privacy
          and comply with the all relevant data protection laws and this privacy
          notice.
        </p>
      </>
    )}
    {section === HOW_DO_WE_OBTAIN_YOUR_CONSENT && (
      <p className="privacy-policy-content-text">
        Where our use of your personal information requires your consent, such
        consent will be provided in accordance with the applicable term and
        conditions of use on our website or any other contract we may have
        entered into with you or as set out in our communication with you from
        time to time. If we rely on your consent as our legal basis for
        processing your personal information, you have the right to withdraw
        that consent at any time by contacting us using the contact details set
        out in this privacy notice.
      </p>
    )}
    {section === MANAGEMENT_OF_PERSONAL_INFORMATION && (
      <p className="privacy-policy-content-text">
        We always take appropriate technical and organisational measures to
        ensure that your information is secure. In particular, we train our
        employees who handle personal information to respect the confidentiality
        of customer information and the privacy of individuals. We regard
        breaches of your privacy very seriously and will impose appropriate
        penalties, including dismissal where necessary.
      </p>
    )}
    {section === HOW_DO_WE_STORE_PERSONAL_INFORMATION && (
      <>
        <p className="privacy-policy-content-text">
          Safeguarding the privacy of your information is important to us,
          whether you interact with us personally, by phone, by mail, over the
          internet or any other electronic medium. We hold personal information
          in a combination of secure computer storage facilities and paper-based
          files and other records, and take steps to protect the personal
          information we hold from misuse, loss, unauthorised access,
          modification or disclosure. When we consider that personal information
          is no longer needed, we will remove any details that will identify you
          or we will securely destroy the records. However, we may need to
          maintain records for a significant period of time.
        </p>
        <p className="privacy-policy-content-text">
          If we hold any personal information in the form of a deed, we will
          hold this deed in its complete form for a period of 12 years after our
          business relationship with you has ended. If we hold any personal
          information in the form of a recorded communication, by telephone,
          electronic, in person or otherwise, this information will be held in
          line with local regulatory requirements which will either be 5 years
          or 10 years after our business relationship with you has ended. Where
          you have opted out of receiving marketing communications we may hold
          your details on our suppression list so that we know you do not want
          to receive these communications but we will not send you marketing
          communications.
        </p>
      </>
    )}
    {section === HOW_DO_WE_USE_THE_PERSONAL_INFORMATION && (
      <>
        <p className="privacy-policy-content-text">
          We may use personal information for the following purposes:
        </p>
        <ol className="privacy-policy-content-text">
          <li>
            <p className="privacy-policy-content-text">
              <b>
                To verify your identity and establish and manage your account
              </b>
            </p>
            <p className="privacy-policy-content-text">
              As part of providing services or information about our services to
              you, we will need to verify your identify to set you up as a
              customer and we will need to use those details in order to
              effectively manage your account with us to ensure that you are
              getting the best possible service from us. This may include third
              parties carrying out credit or identity or checks on our behalf.
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>
                To provide you with products and services, or information about
                our products and services, and to review your ongoing needs
              </b>
            </p>
            <p className="privacy-policy-content-text">
              Once you become a customer, or subscribe to our website or blogs,
              we will need to use your personal information to perform our
              services and comply with our obligations to you. It is also in our
              legitimate interests to ensure that we are providing the most
              appropriate products and services so we may periodically review
              your needs to ensure that you are getting the benefit of the best
              possible products and services from us.
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>
                To help us improve our products and services, including customer
                services, and develop and market new products and services
              </b>
            </p>
            <p className="privacy-policy-content-text">
              We may from time to time use personal information provided by you
              through your use of the services and/or through customer surveys
              to help us improve our products and services. It is in our
              legitimate interests for us to use your personal information in
              this way to ensure that we provide you with the best products and
              services we can and to continue to be a market leader in our
              industry.
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>To investigate or settle enquiries or disputes</b>
            </p>
            <p className="privacy-policy-content-text">
              We may need to use personal information collected from you to
              investigate issues and/or settle disputes with you as it is in our
              legitimate interests to ensure that issues and/or disputes get
              investigated and resolved as quickly and efficiently as possible
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>
                To comply with applicable law, court order, other judicial
                process, or the requirements of any applicable regulatory
                authorities
              </b>
            </p>
            <p className="privacy-policy-content-text">
              We may need to use your personal information to comply with
              applicable law, court order or other judicial process, or the
              requirements of any applicable regulatory authority. We do this
              not only to comply with our legal obligations but because it may
              also be in our legitimate interest to do so.
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>Data analysis</b>
            </p>
            <p className="privacy-policy-content-text">
              Our web pages and e-mails may contain web beacons or pixel tags or
              any other similar type of data analysis tools which allow us to
              track receipt of correspondence and to count the number of users
              that have visited our webpage or opened our correspondence. Where
              your personal information is completely anonymised, we do not
              require a legal basis as the information will no longer constitute
              personal information. However where your personal information is
              not in an anonymised form, it is in our legitimate interest to
              continually evaluate that personal information to ensure that the
              products and services we provide are relevant to the market.
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>Marketing by us</b>
            </p>
            <p className="privacy-policy-content-text">
              We may use your personal information to send you marketing
              communications by email or phone or other agreed forms (including
              social media campaigns) to ensure that you are always kept up to
              date with our latest products and services. Where we send you
              marketing communications we will either do so as it is in our
              legitimate interest or with your consent.
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>Internal business purposes and record keeping</b>
            </p>
            <p className="privacy-policy-content-text">
              We may need to process your personal information for internal
              business and record keeping purposes. Such processing is in our
              own legitimate interests and is required in order to comply with
              our legal obligations. This may include any communications that we
              have with you in relation to the services we provide to you and
              our relationship with you. We will also keep records to ensure
              that you comply with your obligations under any contract you have
              entered into with us.
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>Corporate restructuring</b>
            </p>
            <p className="privacy-policy-content-text">
              If we undergo a corporate restructure or part or all of our
              business is acquired by a third party, we may need to use your
              personal information in association with that restructure or
              acquisition. Such use may involve disclosing your details as part
              of a due diligence exercise. It is our legitimate interest to use
              your information in this way provided we comply with any legal
              obligation we have to you.
            </p>
          </li>
          <li>
            <p className="privacy-policy-content-text">
              <b>Security</b>
            </p>
            <p className="privacy-policy-content-text">
              If you enter any of our premises we may record your image on our
              CCTV for security reasons. We may also take your details to keep a
              record of who has entered our premises on any given day. It is in
              our legitimate interest to do this to maintain a safe and secure
              working environment.
            </p>
          </li>
        </ol>
      </>
    )}
    {section === THE_PERSONAL_INFORMATION_WE_HOLD_ABOUT_YOU && (
      <>
        <p className="privacy-policy-content-text">
          The information about any rights that might be available to you in
          relation to the personal information we hold about you is set out
          below.
        </p>
        <p className="privacy-policy-content-text">
          <b>Rectification</b>
        </p>
        <p className="privacy-policy-content-text">
          If the personal information we hold about you is inaccurate or
          incomplete, you are entitled to have it rectified. If you ask us,
          where possible and lawful to do so, we will also tell you who we have
          shared your personal information with so that you can contact them
          directly.
        </p>
        <p className="privacy-policy-content-text">
          <b>Erasure</b>
        </p>
        <p className="privacy-policy-content-text">
          You can ask us to delete or remove your personal information in
          certain circumstances such as where we no longer need it or you
          withdraw your consent (where applicable) provided that we have no
          legal obligation to retain that data. Such request will be subject to
          any retention limits we are required to comply with in accordance with
          applicable laws and regulations and subject to section ‘How do we
          store personal information and for how long’.
        </p>
        <p className="privacy-policy-content-text">
          <b>Processing restrictions</b>
        </p>
        <p className="privacy-policy-content-text">
          You can ask us to ‘block’ or suppress the processing of your personal
          information in certain circumstances such as where you contest the
          accuracy of that personal information or object to us processing it.
          It will not stop us from storing your personal information though. We
          will tell you before we lift any restriction. If we have shared your
          personal information with others, we will let them know about the
          restriction where possible. If you ask us, where possible and lawful
          to do so, we will also tell you who we have shared your personal
          information with so that you can contact them directly.
        </p>
        <p className="privacy-policy-content-text">
          <b>Data Portability</b>
        </p>
        <p className="privacy-policy-content-text">
          Under the General Data Protection Regulation (679/2016), you have the
          right, in certain circumstances, to obtain personal information you
          have provided us with (in a structured, commonly used and machine
          readable format) and to reuse it elsewhere or ask us to transfer this
          to a third party of your choice.
        </p>
        <p className="privacy-policy-content-text">
          <b>Objection</b>
        </p>
        <p className="privacy-policy-content-text">
          You can ask us to stop processing your personal information, and we
          will do so, except if we can demonstrate compelling legal grounds for
          the processing.
        </p>
      </>
    )}
    {section === WHAT_IS_A_COOKIE && (
      <p className="privacy-policy-content-text">
        A cookie is a small piece of text stored on your computer or device when
        you visit a website. We use cookies on our website to provide you with a
        more relevant and effective experience, including presenting web pages
        according to your needs or preferences. For further information about
        cookies and how we use cookies, please refer to our website.
      </p>
    )}
    {section === TECHNOLOGY_IMPROVEMENTS && (
      <p className="privacy-policy-content-text">
        We are constantly striving to improve functionality on this site through
        technology changes. This may mean a change to the way in which personal
        information is collected or used. The impact of any technology changes
        which may affect your privacy will be notified in this privacy notice at
        the time of the change.
      </p>
    )}
    {section === LINKS_TO_THIRD_PARTY_WEBSITES && (
      <p className="privacy-policy-content-text">
        Our website or our apps may have links to external third party website.
        Please note, however, that third party website are not covered by this
        privacy notice and those sites are not subject to our privacy standards
        and procedures. Please check with each third party as to their privacy
        practices and procedures.
      </p>
    )}
    {section === WHAT_IF_YOU_HAVE_A_COMPLAINT && (
      <>
        <p className="privacy-policy-content-text">
          If you have a concern about any aspect of our privacy practices, you
          can make a complaint. This will be acted upon promptly. To make a
          complaint, please contact us via one of the methods set below. If you
          are not satisfied with our response to your complaint, you have the
          right to lodge a complaint with our supervisory authority, the
          Information Commissioner’s Office (ICO). You can find details about
          how to do this on the ICO website at https://ico.org.uk/concerns/ or
          by calling their helpline on 0303 123 1113.
        </p>
        <p className="privacy-policy-content-text">
          We may update this Privacy Policy from time to time. We will notify
          you of any changes by posting the new Privacy Policy on the Site. You
          are advised to review this Privacy Policy periodically for any
          changes.
        </p>
      </>
    )}
    {section === CONTACT_US && (
      <>
        <p className="privacy-policy-content-text">
          If you have any questions about this Privacy Policy, please feel free
          to contact us.
        </p>
        <p className="privacy-policy-content-text">
          Kaizen Reporting Limited is a company registered in England and Wales
          with company number 08362415
        </p>
        <p className="privacy-policy-content-text">
          Kaizen Shareholding Disclosure Services Limited is a company
          registered in England and Wales with company number 08009973
        </p>
        <p className="privacy-policy-content-text">
          Single Rulebook Limited is a company registered in England and Wales
          with company number 12008959
        </p>
        <p className="privacy-policy-content-text">Registered Offices</p>
        <p className="privacy-policy-content-text">
          Kaizen Regtech Group Limited
          <br />
          30 St Mary Axe (The Gherkin)
          <br />
          London
          <br />
          EC3A 8BF
        </p>
      </>
    )}
  </div>
)

Content.propTypes = {
  section: PropTypes.string.isRequired,
}

export default Content
